import { useAppSelector } from '@/redux/hooks/hooks';
import { ChevronDown, FilterIcon } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react'

interface SortAssignmentsProps {
    selectedFilter: string;
    onFilterChange: (filter: string) => void;
  }
  
  const filterOptions = [
    {
      title: "All",
      value: "all",
    },
    {
      title: "Pending",
      value: "pending",
    },
    {
      title: "Approved",
      value: "approved",
    },
    {
      title: "Rejected",
      value: "rejected",
    },
  ];
const SortWithdrawRequests = ({
    selectedFilter,
    onFilterChange,
  }: SortAssignmentsProps) => {
    const isExpanded = useAppSelector((state) => state.sidebar.isExpanded);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
  
    const toggleDropdown = () => setIsOpen(!isOpen);
  
    const handleFilterSelect = (filter: string) => {
      onFilterChange(filter);
      setIsOpen(false);
    };
  
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target as Node)
        ) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);
  
    return (
      <div
        className="relative inline-block text-left whitespace-nowrap"
        ref={dropdownRef}
      >
        <div className="flex items-center gap-x-1">
          <p>Filter : </p>
          <div>
            <button
              type="button"
              onClick={toggleDropdown}
              className="inline-flex items-center justify-between w-full px-4 py-2.5 text-[#344054] text-sm tracking-[-1%] leading-5 font-medium bg-white border border-[#E4E7EC] rounded-[32px] hover:bg-gray-50 focus:outline-none"
            >
              {isExpanded ? <FilterIcon /> : <span className='capitalize'>{selectedFilter}</span>}
              <ChevronDown className="w-5 h-5 ml-1" aria-hidden="true" />
            </button>
          </div>
        </div>
  
        {isOpen && (
          <div className="absolute right-0 w-40 mt-2 origin-top-right bg-white rounded-md shadow-lg border border-[#E4E7EC]">
            <div
              className="py-1"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
            >
              {filterOptions.map((filter) => (
                <button
                  key={filter.value}
                  onClick={() => handleFilterSelect(filter.value)}
                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 w-full text-left"
                  role="menuitem"
                >
                  {filter.title}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  export default SortWithdrawRequests
  